module.exports = __webpack_public_path__ + "static/media/south_indian.48e9fb04.jpg";